import { dateToIso, isIsoInRange } from "./iso";
import { getDaySelectionAppearance, parseIsoRange, parseMultipleIsos } from "./selection";
export function getWeekStartsOn(locale) {
  const tag = resolveLocaleTag(locale);
  try {
    const resolved = new Intl.Locale(tag);
    const weekInfo = resolved.weekInfo;
    if (weekInfo?.firstDay != null) {
      return weekInfo.firstDay === 7 ? 0 : weekInfo.firstDay;
    }
  } catch {}
  return tag.startsWith("en-US") ? 0 : 1;
}
function resolveLocaleTag(locale) {
  if (Array.isArray(locale)) {
    return locale[0] ?? navigator.language;
  }
  return locale ?? navigator.language;
}
function startOfDay(date) {
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}
function isSameDay(a, b) {
  return a.getFullYear() === b.getFullYear() && a.getMonth() === b.getMonth() && a.getDate() === b.getDate();
}
function resolveSelectionContext(options) {
  const mode = options.selectionMode ?? "single";
  const value = options.value ?? "";
  if (mode === "multiple") {
    return {
      mode,
      multipleIsos: parseMultipleIsos(value)
    };
  }
  if (mode === "range") {
    const committed = parseIsoRange(value);
    if (options.rangeDraft?.anchor) {
      const hover = options.rangeDraft.hover ?? options.rangeDraft.anchor;
      return {
        mode,
        range: normalizeRangeFromDraft(options.rangeDraft.anchor, hover)
      };
    }
    return {
      mode,
      range: committed
    };
  }
  return {
    mode,
    singleIso: value || void 0
  };
}
function normalizeRangeFromDraft(anchor, hover) {
  if (anchor.localeCompare(hover) <= 0) {
    return {
      start: anchor,
      end: hover
    };
  }
  return {
    start: hover,
    end: anchor
  };
}
export function buildCalendarMonth(year, month, options) {
  const weekStartsOn = getWeekStartsOn(options.locale);
  const today = startOfDay(options.today ?? /* @__PURE__ */new Date());
  const selection = resolveSelectionContext(options);
  const firstOfMonth = new Date(year, month, 1);
  const startOffset = (firstOfMonth.getDay() - weekStartsOn + 7) % 7;
  const gridStart = new Date(year, month, 1 - startOffset);
  const weeks = [];
  const cursor = new Date(gridStart);
  for (let week = 0; week < 6; week += 1) {
    const row = [];
    for (let day = 0; day < 7; day += 1) {
      const iso = dateToIso(cursor);
      const appearance = getDaySelectionAppearance(iso, selection.mode, {
        singleIso: selection.singleIso,
        multipleIsos: selection.multipleIsos,
        range: selection.range
      });
      row.push({
        date: new Date(cursor),
        iso,
        inMonth: cursor.getMonth() === month,
        isToday: isSameDay(cursor, today),
        isSelected: appearance.isSelected,
        isDisabled: !isIsoInRange(iso, options.min, options.max),
        isRangeStart: appearance.isRangeStart,
        isRangeEnd: appearance.isRangeEnd,
        isRangeMiddle: appearance.isRangeMiddle
      });
      cursor.setDate(cursor.getDate() + 1);
    }
    weeks.push(row);
    if (week >= 4 && cursor.getMonth() !== month && cursor.getDate() > 7) {
      break;
    }
  }
  return weeks;
}